var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-platform-account" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm._m(0),
        _c("div", { staticClass: "text" }, [_vm._v("基础信息")]),
        _c("platform-account-form", { ref: "platformAccountForm" }),
        _c(
          "div",
          {
            staticClass: "footer",
            class: [_vm.isCollapsed ? "footer-collapsed" : ""],
          },
          [
            _c(
              "el-button",
              { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.reset },
              },
              [_vm._v("重置")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.btnSave },
                on: { click: _vm.save },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("新增平台账号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }